import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const BubbleIcon = ({ width = "24", height = "24" }: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 18C6.4 18 5.45833 17.6083 4.675 16.825C3.89167 16.0417 3.5 15.1 3.5 14C3.5 12.9 3.89167 11.9583 4.675 11.175C5.45833 10.3917 6.4 10 7.5 10C8.6 10 9.54167 10.3917 10.325 11.175C11.1083 11.9583 11.5 12.9 11.5 14C11.5 15.1 11.1083 16.0417 10.325 16.825C9.54167 17.6083 8.6 18 7.5 18ZM8.912 15.413C8.52067 15.8043 8.05 16 7.5 16C6.95133 16.0027 6.48067 15.807 6.088 15.413C5.69533 15.019 5.49933 14.548 5.5 14C5.50067 13.452 5.69667 12.9813 6.088 12.588C6.47933 12.1947 6.95 11.9987 7.5 12C8.05 12.0013 8.521 12.1973 8.913 12.588C9.305 12.9787 9.50067 13.4493 9.5 14C9.49933 14.5507 9.30333 15.0217 8.912 15.413Z"
          fill="#A4B1C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 14C15.4667 14 14.1667 13.4667 13.1 12.4C12.0333 11.3333 11.5 10.0333 11.5 8.5C11.5 6.96667 12.0333 5.66667 13.1 4.6C14.1667 3.53333 15.4667 3 17 3C18.5333 3 19.8333 3.53333 20.9 4.6C21.9667 5.66667 22.5 6.96667 22.5 8.5C22.5 10.0333 21.9667 11.3333 20.9 12.4C19.8333 13.4667 18.5333 14 17 14ZM19.488 10.988C18.8127 11.6627 17.9833 12 17 12C16.018 12.0013 15.189 11.664 14.513 10.988C13.837 10.312 13.4993 9.48267 13.5 8.5C13.5007 7.51733 13.838 6.68833 14.512 6.013C15.186 5.33767 16.0153 5 17 5C17.9847 5 18.814 5.33733 19.488 6.012C20.162 6.68667 20.4993 7.516 20.5 8.5C20.5007 9.484 20.1633 10.3133 19.488 10.988Z"
          fill="#496389"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 21C14.1667 21 13.4583 20.7083 12.875 20.125C12.2917 19.5417 12 18.8333 12 18C12 17.1667 12.2917 16.4583 12.875 15.875C13.4583 15.2917 14.1667 15 15 15C15.8333 15 16.5417 15.2917 17.125 15.875C17.7083 16.4583 18 17.1667 18 18C18 18.8333 17.7083 19.5417 17.125 20.125C16.5417 20.7083 15.8333 21 15 21ZM15.713 18.712C15.521 18.904 15.2833 19 15 19C14.718 19.0013 14.4807 18.9057 14.288 18.713C14.0953 18.5203 13.9993 18.2827 14 18C14.0007 17.7173 14.0967 17.48 14.288 17.288C14.4793 17.096 14.7167 17 15 17C15.2833 17 15.5207 17.096 15.712 17.288C15.9033 17.48 15.9993 17.7173 16 18C16.0007 18.2827 15.905 18.52 15.713 18.712Z"
          fill="#778AA7"
        />
        <defs>
          <rect
            width={width}
            height={width}
            fill="white"
            transform="translate(0.5)"
          />
        </defs>
      </svg>
    </IconWrapper>
  );
};
